// ProofType.model.ts

export interface IProofType {
  proofTypeId: string;
  name: string;
  description: string;
  showed: boolean;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

export class ProofType {
  proofTypeId: string;
  name: string;
  description: string;
  showed: boolean;
  status: boolean;
  imageBase64: string = '';
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IProofType) {
    this.proofTypeId = data.proofTypeId;
    this.name = data.name;
    this.description = data.description;
    this.showed = data.showed;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }
}
